import { Button, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { AccountMovement, GetMovementsListQuery } from '../../../API';
import { useAppSelector } from '../../../app/hooks';
import { PlayerMode, PlayerState, selectPlayer } from '../../../features/player/playerSlice';
import { selectTheme, ThemeMode } from '../../../features/theme/themeSlice';

import PrintPlacebet from '../../../views/account/components/PrintPlacebet';
import AccountBalance from './AccountBalance';
import ProfileButton from './ProfileButton';
import { GraphQLResult, GRAPHQL_AUTH_MODE } from '@aws-amplify/api-graphql';
import { API } from 'aws-amplify';

type LoggedControlsProps = {
	player: PlayerState;
};

const LoggedControls = ({ player }: LoggedControlsProps) => {
	const theme = useAppSelector(selectTheme);

	return (
		<>
			<div className="d-flex f-row logged-controls">
				{!theme.isMobile && (
					<>
						<div className="d-username">
							{theme.mode === ThemeMode.KIOSK
								? player.displayName
									? player.displayName
									: player.username.split('@')[0]
								: player.username}
						</div>
						<AccountBalance />
					</>
				)}

				{player.mode === PlayerMode.DEFAULT && <ProfileButton />}
			</div>
		</>
	);
};

export default LoggedControls;
